interface ISelectedFilterValues {
	values: { size: number };
}

interface IFilterLoadState {
	isInitialized: boolean;
	isLoading: boolean;
}

interface IApiFilterColumn {
	key: string;
	filter?: { api?: unknown };
}

interface IApiFiltersToLoadParams<TColumn extends IApiFilterColumn> {
	columns: TColumn[];
	selectedFilters?: Record<string, ISelectedFilterValues>;
	filterStates?: Record<string, IFilterLoadState | undefined>;
}

/**
 * API filter options load only when their group is opened. A selection restored from the URL
 * has values and no labels until those options exist, so columns in that state need a load.
 * A column whose state is not registered yet is skipped; the initial pass still has to record it.
 */
export function getApiFilterColumnsToLoad<TColumn extends IApiFilterColumn>({
	columns,
	selectedFilters,
	filterStates,
}: IApiFiltersToLoadParams<TColumn>): TColumn[] {
	if (!selectedFilters || !filterStates) {
		return [];
	}

	return columns.filter(column => {
		if (!column.filter?.api) {
			return false;
		}
		const selected = selectedFilters[column.key];
		if (!selected?.values.size) {
			return false;
		}
		const state = filterStates[column.key];
		if (!state || state.isInitialized || state.isLoading) {
			return false;
		}
		return true;
	});
}
